// extracted by mini-css-extract-plugin
export default {"phoneImgContainer":"G8d037e","phoneImg":"G9d74aa"};